import { object, string } from "yup"

export const ComponentFormSchema = object({
  name: string().required(),
})
